export default __webpack_public_path__ + "static/media/dc-arrow.15b27bc2.jpg";